<template>
  <v-container>
    <PtSheet no-highlight>
      <div>
        <div class="pb-12">
          <v-row class="pt-5">
            <img
              class="center mb-5"
              src="@/assets/vendorproof-shadowmark@2x.png"
              alt="VendorProof Logo"
              width="82"
              height="82"
            />
          </v-row>
          <v-row class="justify-center">
            <div style="font-size: 20px">
              Create a new VendorProof Account.
            </div>
          </v-row>
        </div>
        <v-form v-model="formValid" @submit.prevent="save">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                v-model="form.username"
                label="Username*"
                :rules="[rules.required(), rules.notBlank(), maxChars(255)]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
                outlined
                v-model="form.firstName"
                label="First Name*"
                :rules="[rules.required(), rules.notBlank(), maxChars(255)]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                outlined
                v-model="form.lastName"
                label="Last Name*"
                :rules="[rules.required(), rules.notBlank(), maxChars(255)]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-text-field
                outlined
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                label="Password*"
                :rules="passwordRules"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                outlined
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="form.confirmPassword"
                label="Confirm Password*"
                :rules="passwordRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                v-model="form.phoneNumber"
                label="Phone Number*"
                :rules="[rules.required(), rules.phoneNumber]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                v-model="form.email"
                label="Email*"
                :rules="emailRules"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                outlined
                v-model="form.confirmEmail"
                label="Confirm Email*"
                :rules="emailRules"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-0 py-0">
            <v-col cols="12" class="my-0 py-0 ">
              <v-checkbox
                label="I consent to ProviderTrust and its agents and representatives contacting me via text, call, and or voicemail
               at the number provided regarding my VendorProof enrollment and any other products and services offered by
                ProviderTrust. Messages may be sent by an automatic dialing or messaging system.
                 Consent not required as a condition of purchase."
                class=" colorNeutralsNavy400--text"
                v-model="form.consentToContact"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row class="my-0 py-0 colorNeutralsNavy400--text">
            <v-col cols="12" class="my-0 py-0">
              <v-checkbox v-model="form.acceptTos" :rules="[rules.required()]">
                <template v-slot:label>
                  Yes, I accept the
                  <a
                    @click.stop
                    class="pl-1"
                    href="/client/terms"
                    target="_blank"
                    >Terms of Service</a
                  >
                </template>
              </v-checkbox>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <large-blue-call-to-action
                :disabled="createDisabled"
                type="submit"
                disabled-tooltip-message="Please fill out all required fields"
                block
                >Create Account
              </large-blue-call-to-action>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="colorNeutralsNavy300--text">
              Already have an account?
              <router-link :to="{ name: 'VendorLogin' }">Login</router-link>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </PtSheet>
  </v-container>
</template>

<script>
import * as rules from "@/services/rules";
import {
  email,
  maxChars,
  passwordRegexRules,
  valuesMatch
} from "@/services/rules";
import LargeBlueCallToAction from "@/components/providertrust/buttons/LargeBlueCallToAction.vue";
import PtSheet from "@/components/PtSheet.vue";
import { vendorCreateAccountAPI } from "@/services/api";
import { post } from "@/services/request";
import hasNotifications from "@/mixins/has-notifications";
import store from "@/store";

export default {
  name: "CreateAccount",
  components: { PtSheet, LargeBlueCallToAction },
  data() {
    return {
      waitingForResponse: false,
      formValid: false,
      form: {},
      showPassword: false,
      controls: {},
      rules
    };
  },
  mixins: [hasNotifications],
  computed: {
    passwordRules() {
      return passwordRegexRules.concat([
        rules.required(),
        valuesMatch(
          this.form.password,
          this.form.confirmPassword,
          "Passwords must match"
        )
      ]);
    },
    emailRules() {
      return [email].concat([
        rules.required(),
        maxChars(255),
        valuesMatch(
          this.form.email,
          this.form.confirmEmail,
          "Emails must match"
        )
      ]);
    },
    createDisabled() {
      return !this.formValid || this.waitingForResponse;
    }
  },
  methods: {
    maxChars,
    save() {
      this.waitingForResponse = true;
      post(vendorCreateAccountAPI, this.form)
        .then(() => store.dispatch("user/loadCurrentUser"))
        .then(() => this.$router.push({ name: "connectSignupId" }))
        .catch(error => {
          this.showMessage({
            text:
              "Failed to create user account because " + error.response.data,
            mode: "error"
          });
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input label {
  color: $color-neutrals-navy-400;
}
</style>
